import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getServices = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Service/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error;
  }
};

export const saveService = async (service) => {
  const response = await axios.post(`${BASE_URL}/api/Service/save`, service, {
    headers: getAuthHeader(),
  });
  return response.data;
}; 